// Single source for the right-top tab identifiers: the chat store persists them and the UI
// (Sidecar / sidecarTabEventBus) renders and guards against them. Lives in the SDK so the
// store can reference it without an sdk → components dependency.
export const RIGHT_TOP_TABS = ["ai-assist", "customer", "offers", "guided-flows"] as const;

export type RightTopTab = (typeof RIGHT_TOP_TABS)[number];

export const isRightTopTab = (value: unknown): value is RightTopTab => RIGHT_TOP_TABS.includes(value as RightTopTab);
